class LocalARENA {
  constructor({
    path, mainUrl, useSimpleSignup, ial, unified,
  }) {
    this.arena = true
    this.path = path || 'arena' // sso path
    this.mainUrl = mainUrl || 'https://www.nexon.com/main/en'
    this.useSimpleSignup = useSimpleSignup ?? false
    this.unified = unified
    this.signinPath = `/account${this.unifiedPath}/login?simple_signup=${this.useSimpleSignup}&return_url=`
    this.signinPathForIal = '/account/global/ial/login?return_url='
    this.signoutPath = '/account/logout?return_url='
    this.signupPath = `/account${this.unifiedPath}/create?return_url=`
    this.accountPath = '/account/setting'
    this.ial = ial
  }

  get unifiedPath() {
    return this.unified ? '/unified' : ''
  }

  get signinUrl() {
    return this.mainUrl + (this.ial ? this.signinPathForIal : this.signinPath)
  }

  get signoutUrl() {
    return this.mainUrl + this.signoutPath
  }

  get signupUrl() {
    return this.mainUrl + this.signupPath
  }

  get accountUrl() {
    return this.mainUrl + this.accountPath
  }
}

export default LocalARENA
